import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAlertinline = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 16 16",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8.894 1.789l6.382 12.764A1 1 0 0 1 14.382 16H1.618a1 1 0 0 1-.894-1.447L7.106 1.789a1 1 0 0 1 1.788 0zM7 6v5h2V6H7zm0 6v2h2v-2H7z",
		fill: "currentColor",
		fillRule: "evenodd"
	})
});
export default SvgAlertinline;
